const formatHrefToPath = (href, queryStrings = true) => {
  const url = new URL(href, window.location.origin);
  return url.pathname + (queryStrings ? url.search : "");
};
/**
 * Checks if a given path is a defined vue route.
 * @returns {boolean}
 * @param targetPath
 */
const isVueRoute = (targetPath) => {
  const formatted = formatHrefToPath(targetPath, false);
  let foundAMatch = false;
  window.main.$router.matcher.getRoutes().every((route) => {
    const match = route.regex.exec(formatted);
    // Break when a match is found...
    if (match) {
      foundAMatch = true;
      return false;
    }
    // Continue looping...
    return true;
  });
  return foundAMatch;
};

const isCurrentVueRoute = (targetPath) => {
  const formatted = formatHrefToPath(targetPath);
  let targetPathIsCurrentRoute = false;
  window.main.$router.matcher.getRoutes().every((route) => {
    const isAVueRoute = route.regex.exec(formatted);
    // Break when a match is found...
    if (isAVueRoute && formatted === window.location.pathname) {
      targetPathIsCurrentRoute = true;
      return false;
    }
    // Continue looping...
    return true;
  });
  return targetPathIsCurrentRoute;
};

export {
  formatHrefToPath,
  isVueRoute,
  isCurrentVueRoute,
};
